import { Component } from '@theme/component';

class BundleOffers extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    const selected = this.variants.find(v => String(v.id) === this.closest('form').elements.id.value);
    if (selected) {
      this.querySelector(`input[value="${parseInt(selected.options[0], 10)}"]`).checked = true;
      const shades = (selected.options[1] || '').split(' + ');
      this.querySelectorAll('.bundle-offers__shades select').forEach((select, i) => {
        select.value = shades[i] || shades[0];
      });
    }
    this.sync();
  }

  sync() {
    const count = Number(this.querySelector('input[type="radio"]:checked').value);
    const shades = [];
    this.querySelectorAll('.bundle-offers__shades select').forEach((select, i) => {
      select.closest('label').hidden = i >= count;
      if (i < count) shades.push(select.value);
    });
    const mix = shades.sort().join(' + ');
    this.variant = this.variants.find(v => parseInt(v.options[0], 10) === count && (v.options[1] || '') === mix);
    const valid = Boolean(this.variant?.available);
    const form = this.closest('form');
    const subscription = this.querySelector('[data-subscription]');
    let subscriptionValid = true;
    let subscribed = false;
    if (subscription) {
      const checkbox = this.querySelector('[data-subscribe]');
      const select = this.querySelector('[name="selling_plan"]');
      const eligible = valid && count === 2 && this.variant.plans.length > 0;
      subscription.hidden = !eligible;
      checkbox.disabled = !eligible;
      if (!eligible) checkbox.checked = false;
      subscribed = eligible && checkbox.checked;
      select.disabled = !subscribed;
      this.querySelector('[data-subscription-terms]').hidden = !subscribed;
      subscriptionValid = !subscribed || this.variant.plans.some(plan => String(plan.id) === select.value);
      const option = select.selectedOptions[0];
      if (option) {
        this.querySelector('[data-subscription-summary]').textContent = option.dataset.summary;
        this.querySelector('[data-subscription-terms]').textContent = option.dataset.terms;
      }
    }
    form.elements.id.value = valid ? this.variant.id : '';
    form.querySelector('button[type="submit"]').disabled = !valid || !subscriptionValid;
    this.querySelector('[data-offer-shipping]').hidden = !valid || (!subscribed && this.variant.price < 3500);
    this.querySelector('[data-offer-error]').hidden = valid && subscriptionValid;
  }

  getItems() {
    this.sync();
    if (!this.variant?.available) throw new Error(this.dataset.unavailable);
    const select = this.querySelector('[name="selling_plan"]');
    const sellingPlanId = select && !select.disabled ? select.value : null;
    if (select && !select.disabled && !this.variant.plans.some(plan => String(plan.id) === sellingPlanId)) {
      throw new Error(this.dataset.unavailable);
    }
    const items = [{ variantId: String(this.variant.id), quantity: 1, ...(sellingPlanId ? { sellingPlanId } : {}) }];
    return items;
  }
}

if (!customElements.get('bundle-offers')) customElements.define('bundle-offers', BundleOffers);
